import React from 'react';

const Card = ({id, name, email}) =>{
	return(
		<div className='tc bg-light-green grow pa3 ma2 dib br3 shadow-5'>
			<img alt='robot' src={`https://robohash.org/${id}?200x200`} />
			<div>
				<h2>{name}</h2>
				<p>{email}</p>
			</div>
		</div>
	);
}

export default Card;